// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__pexAZ","label":"Section_label__3EpQ7","contentWrap":"Section_contentWrap__8dqcU","footer":"Section_footer__2kCNL","footerInner":"Section_footerInner__3lHa6"};